module.exports = __webpack_public_path__ + "img/dingbu-banner-tuya.531e88ec.png";